const ChessTypes = {
  NONE: '无棋',
  NORMAL: '有棋',
};

export default ChessTypes;
